import { render, staticRenderFns } from "./ProductDetailAccordionSet.vue?vue&type=template&id=36814be2&scoped=true&"
import script from "./ProductDetailAccordionSet.vue?vue&type=script&lang=js&"
export * from "./ProductDetailAccordionSet.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailAccordionSet.vue?vue&type=style&index=0&id=36814be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36814be2",
  null
  
)

export default component.exports